import TitleImage from './TitleImage'

export default TitleImage
